import { defineNuxtPlugin } from '#app'
import useAuthUserMixin from '~~/mixins/useAuthUserMixin'
import layoutCheckerMixin from '~~/mixins/layoutCheckerMixin.js'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.mixin(useAuthUserMixin)
    nuxtApp.vueApp.mixin(layoutCheckerMixin)
})
